import {
  DocumentDuplicateIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/daisy';
import useCopyScheduledLessonReport from '@/data/hook/scheduled-lesson-report/useCopyScheduledLessonReport';
import Klass from '@/models/Klass';
import ScheduledLesson from '@/models/ScheduledLesson';

export type CopyScheduledLessonReportButtonProps = {
  scheduledLesson: ScheduledLesson;
  klass: Klass;
};

export default function CopyScheduledLessonReportButton({
  scheduledLesson,
  klass,
}: CopyScheduledLessonReportButtonProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'scheduledLessonReportModal',
  });

  const { copyReport, isLoading, isCopied } = useCopyScheduledLessonReport({
    scheduledLesson,
    klass,
  });

  const Icon = isCopied ? (
    <CheckCircleIcon className="size-4" />
  ) : (
    <DocumentDuplicateIcon className="size-4" />
  );

  return (
    <div className="flex justify-end">
      <Button
        color="primary"
        size="md"
        variant="soft"
        className="w-fit"
        onClick={copyReport}
        disabled={isLoading}
      >
        {Icon}
        {t('copyScheduledLessonReport')}
      </Button>
    </div>
  );
}
